import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {
  BusinessUnitKycListComponent,
} from "./components";

const routes: Routes = [
  {path: '', component: BusinessUnitKycListComponent},
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KycRoutingModule {}
